import { ApiService } from "./api.service";
import { PrimeIcons } from "@primevue/core/api";
import { DOMAIN } from "./domain-constant";
import { AppIcons } from "../constants/app-icons";
export default class WarehouseService extends ApiService {
  namespace = "warehouse";
  icon = "PalletizedBoxes";
  name = "Category";
  favicon = "BoxWithLabel";
  window = 290;
  Width = 900;
  DOMAIN = DOMAIN.WAREHOUSE;
  action = "action";
  singular = this.terminology.warehouse.singular;
  plural = this.terminology.warehouse.plural;
  vowel = this.terminology.warehouse.vowel;
  navItems = [
    {
      key: "listing",
      label: this.t("allEntity", { entity: this.plural }),
      icon: AppIcons.BULLETS,
    },
    {
      key: "bookmark",
      label: this.t("viewMyBookmarks", { entity: this.singular }),
      icon: AppIcons.BOOKMARK,
    },
    {
      key: "inactive",
      label: this.t("viewInactiveEntity", { entity: this.plural }),
      services: DOMAIN.VENDOR,
      icon: AppIcons.DISABLE,
    },
  ];
  columns = [
    {
      header: this.t("displayName"),
      icon: AppIcons.TAG,
      field: "display_name",
    },
    {
      header: "Locations",
      icon: AppIcons.TAG,
      field: "Number",
    },
    {
      header: "Created By",
      icon: AppIcons.USER_SILHOUETTE,
      field: "Number",
      template: () => {
        return "PloionGroup";
      },
    },
    {
      header: this.t("Created"),
      icon: AppIcons.CALENDAR,
      field: "created_at",
      template: (data) => {
        return new Date(data.created_at * 1000).toLocaleDateString("en-US");
      },
    },
  ];
  gemMenuItems = [
    {
      key: "create",
      label: "Adding a Warehouse",
      icon: AppIcons.LIST,
    },
  ];
  listMenuItems = [
    {
      key: "edit",
      label: "Edit an Warehouse",
      icon: AppIcons.EDIT,
    },
    {
      key: "announce",
      label: "announceThisEntity",
      services: DOMAIN.MESSAGES,
      icon: AppIcons.LIST,
    },
    {
      key: "email",
      label: "emailThisEntity",
      icon: AppIcons.MAIL,
    },
    {
      key: "bookmark",
      label: "bookmarkThisEntity",
      icon: AppIcons.BOOKMARK,
    },
    {
      key: "inactive",
      label: "inactiveThisEntity",
      icon: AppIcons.LOCK2,
    },
  ];

  constructor() {
    super("warehouses");
  }
}
